import { PayloadAction } from '@reduxjs/toolkit';
import { Login } from 'types/Login';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { ContainerState } from './types';

// The initial state of the ConventionalLogin container
export const initialState: ContainerState = {
  login: { data: {}, loading: false, error: false },
  routes: []
};

const conventionalLoginSlice = createSlice({
  name: 'conventionalLogin',
  initialState,
  reducers: {
    requestLogin(state, action: PayloadAction<any>) {
      state.login.loading = true;
      state.login.data = {};
    },
    requestLoginSuccess(state, action: PayloadAction<Login>) {
      state.login.data = action.payload;
      state.login.loading = false;
    },
    requestLoginError(state, action: PayloadAction<any>) {
      state.login.error = action.payload;
      state.login.loading = false;
    },
    setRoutes(state, action: PayloadAction<any>) {
      state.routes = action.payload
    }
  },
});

export const { actions, reducer, name: sliceKey } = conventionalLoginSlice;
